import { useFormContext } from 'react-hook-form';

import useLocalStorage from 'hooks/useLocalStorage';
import useFilterFormContext from './useFilterFormContext';

const useFilterFormContextFormHandlers = <T extends object>() => {
  const {
    reset,
    formState: { defaultValues },
  } = useFormContext<T>();
  const {
    filtersLocalStorageKey,
    schema,
    searchFieldRef,
    setLastSubmittedFilters,
  } = useFilterFormContext<T>();
  const { setValue: storeFilterFormValue, clearLocalStorage } =
    useLocalStorage<T>(filtersLocalStorageKey);

  const handleSubmit = (formValues: T) => {
    const nextFormValues = schema.cast(
      { ...formValues },
      { stripUnknown: true },
    );

    storeFilterFormValue(nextFormValues);
    setLastSubmittedFilters(nextFormValues);
  };

  const handleClear = () => {
    reset();
    searchFieldRef.current?.clear();
    clearLocalStorage();
    setLastSubmittedFilters(defaultValues as T);
  };

  return {
    handleClear,
    handleSubmit,
  };
};

export default useFilterFormContextFormHandlers;
